var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 5.70711C9.6097 5.31658 8.97654 5.31658 8.58601 5.70711C8.19549 6.09763 8.19549 6.7308 8.58601 7.12132L13.1718 11.7071L8.58601 16.2929C8.19549 16.6834 8.19549 17.3166 8.58601 17.7071C8.97654 18.0976 9.6097 18.0976 10.0002 17.7071L16.0002 11.7071L10.0002 5.70711Z",
    fill: "#7956D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIcon);
export default __webpack_public_path__ + "static/media/rightArrowIcon.ce4dde1d06b804a487cc829af72e090e.svg";
export { ForwardRef as ReactComponent };